import script from "./SubBannerSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SubBannerSection.vue?vue&type=script&setup=true&lang=js"

import "./SubBannerSection.vue?vue&type=style&index=0&id=3ff99aba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ff99aba"]])

export default __exports__